import wrapURL from './interceptors';

export const isProd = process.env.VUE_APP_ENV=='production';

export const baseURL = wrapURL(
    process.env.VUE_APP_ENV=='production' ? 'https://api.vibrant-wellness.com/v1/portal/trans-service':'https://api.vibrant-wellness.com/v1/portal/trans-service-st'
);

export const inventoryBaseURL = wrapURL(
    process.env.VUE_APP_ENV=='production' ? 'https://api.vibrant-wellness.com/v1/lis/shipping':'https://api.vibrant-wellness.com/v1/lis/shipping/staging'
);

export const coreServiceBaseURL = wrapURL(
    process.env.VUE_APP_ENV == "production" ? "https://api.vibrant-wellness.com/v1/lis/lis-core-service/api" : "https://api.vibrant-wellness.com/v1/lis/lis-corestaging-service/api"
);

export const sampleBaseURL = wrapURL(
    process.env.VUE_APP_ENV == "production" ? "https://api.vibrant-wellness.com/v1/lis/samples" : "https://api.vibrant-wellness.com/v1/lis/samples/staging"
);